module.exports = __webpack_public_path__ + "ed5a55f3a542e6eece20da37466263e0.svg";